import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';

import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { Campaign } from '../../../../models/campaign.model';
import { ARBleCampaign, ARBleCampaignConfiguration } from '../../../../models/agrorendement-ble.model';
import { ARBleService } from '../../../../services/agrorendement-ble.service';
import { ARCampaignNotificationFilter } from '../../../../services/agrorendement-common.service';
import { ARBleUtils } from './ble.utils';
import { Organisation } from '../../../../models/organisation.model';
import { OrganisationService } from '../../../../services/organisation.service';
import { showErrorMessage } from '../../../../utils/utils';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'ar-ble-campaign-email',
  templateUrl: 'campaign-email.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CampaignYearPipe, TranslatePipe, CommonModule, FormsModule],
  providers: [ARBleService, OrganisationService],
})
export class ARBleCampaignEmailComponent implements OnInit {
  error: any;
  sub: any;

  campaigns: ARBleCampaign[];
  organisations: Organisation[];
  messageTypes: any[];

  messageTypeFilter: string = null;
  campaignFilter: number = null;
  organisationFilter: number = null;
  sendEmailToFarmers = false;
  sendEmailToAdvisors = false;

  constructor(
    private bleService: ARBleService,
    private organisationService: OrganisationService,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    // TODO Récupérer ça de la base ?
    this.messageTypes = [
      { code: 'NOTIFICATION_FILL_T3_DATA', label: 'Rappel de remplissage des infos manquantes pour les T3 commandées' },
      {
        code: 'NOTIFICATION_END_OF_CAMPAIGN',
        label: "Avertissement de fin de prise de commandes T3 (date configurée dans l'admin)",
      },
    ];
  }

  ngOnInit() {
    this.getCampaigns();
    this.getOrganisations();
  }

  goBack(savedConfig: ARBleCampaignConfiguration = null) {
    this.router.navigate(['/orders', 'azote', 'ble', 'admin']);
    return false;
  }

  sendEmails() {
    this.modal.confirm('Envoi du mail de notification ?').then((ok: boolean) => {
      if (ok) {
        const notificationFilter = new ARCampaignNotificationFilter();
        notificationFilter.campaign = this.campaignFilter;
        notificationFilter.organisation = this.organisationFilter;
        notificationFilter.sendToFarmers = this.sendEmailToFarmers;
        notificationFilter.sendToAdvisors = this.sendEmailToAdvisors;
        this.bleService.notifyUsersCampaign(notificationFilter, this.messageTypeFilter).subscribe(
          (res: any) => {
            const size: number = res.length;
            this.modal.alert(size + ' notifications envoyées !');
          },
          (error: any) => {
            const msg = "Une erreur est survenue lors de l'envoi des notifications.";
            this.handleSendEmailError(error, msg);
          },
        );
      }
    });
  }

  getCampaigns() {
    this.bleService.getCampaigns().subscribe((campaigns) => {
      this.campaigns = campaigns
        .filter((x) => ARBleUtils.isCampaignCurrentlyOpen(x))
        .sort(Campaign.compare)
        .reverse();
      // la première
      if (this.campaigns.length > 0) {
        this.campaignFilter = this.campaigns[0].id;
      }
    });
  }

  getOrganisations() {
    this.organisationService.getOrganisations().subscribe((orgs) => {
      this.organisations = orgs.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  handleSendEmailError(error: any, msg: string) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à envoyer les emails");
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, "Il y a des erreurs dans l'envoi des notifications");
    }
  }
}
